/** @file Utilities for configuring payments and processing */

export const testId = 'PAYMENTS_AND_PROCESSING';
